import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useAuth } from './context/AuthContext'; // Ajoute AuthProvider
import PrivateRoute from './components/PrivateRoute'; // Ajoute PrivateRoute
// import FormulaireDoctorant from './pages/FormulaireDoctorant';
import ListeDoctorants from './pages/ListeDoctorants';
import ModifierDoctorant from './pages/ModifierDoctorant';
import ModifierDoctorantAdmin from './pages/ModifierDoctorantAdmin';
import Header from './components/Header';
import EnvoiEmail from './pages/sendEmail';
import FormulaireToken from './pages/FormulaireToken';
// import FormulaireRepresentant from './pages/FormulaireRepresentant';
import Login from './components/Login';
import AdminEmailConfig from './pages/AdminEmailConfig';
import AdminQuestionConfig from './pages/AdminQuestionConfig';
import MerciPage from './pages/MerciPage';
import Footer from './components/Footer';
import './App.css';
import { PageMentionInformation, PrivacyNoticePage } from './components/MentionInformation';
import JournalAcces from './pages/JournalAcces';

const App: React.FC = () => {
    const { isAdmin } = useAuth();
    return (
        <Router>
            <div className="App">
                {isAdmin && <Header />}

                <div className="main-content">
                    <Routes>
                        {/* Accès Public */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/formulaire" element={<FormulaireToken />} />
                        <Route path="/modifier/:id" element={<ModifierDoctorant />} />
                        <Route path="/merci" element={<MerciPage />} />
                        <Route path="/donnees-personnelles" element={<PageMentionInformation />} />
                        <Route path="/privacy-notice" element={<PrivacyNoticePage />} />

                        {/* Routes Admin Sécurisées */}
                        <Route element={<PrivateRoute />}>
                            <Route path="/" element={<EnvoiEmail />} />
                            <Route path="/doctorants" element={<ListeDoctorants />} />
                            <Route path="/doctorant/modifier/:id" element={<ModifierDoctorantAdmin />} />
                            <Route path="/email-config" element={<AdminEmailConfig />} />
                            <Route path="/questions" element={<AdminQuestionConfig />} />
                            <Route path="/journal" element={<JournalAcces />} />
                        </Route>
                    </Routes>
                </div>

                <Footer />
            </div>
        </Router>
    );
};

export default App;